/**
 * Trigger a client-side CSV download from an already-rendered CSV string.
 *
 * Kept deliberately tiny + dependency-free: wrap the text in a Blob, mint an
 * object URL, click a temporary anchor, then revoke the URL so we don't leak
 * it. The CSV text itself is produced by the pure `toEarningsStatementCsv` /
 * `toPayoutStatementCsv` helpers in `@kilat/shared` — this file does no money
 * math, it only moves bytes to the user's disk.
 */
export function downloadCsv(filename: string, text: string): void {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
